<template>
  <div class="p-lg">
    <h2 class="m-b-lg">{{ $t('configurator.chooseModalities', { tourName: orderTitle }) }}</h2>
    <card class="overflow-visible">
      <form class="flex overflow-visible">
        <div class="col-4 p-md">
          <label for="peopleCount" class="m-b-xxs block">{{ $t('forms.peopleCount') }}</label>
          <styled-select id="peopleCount" v-model="peopleCountFormData">
            <option
              v-for="option in generateGroupOptions(
                minParticipants,
                maxParticipants,
                $t('forms.persons'),
              )"
              :key="option.value"
              :value="option.value"
              >{{ option.label }}</option
            >
          </styled-select>
        </div>
        <div class="col-4 p-md">
          <label for="playDate" class="m-b-xxs block">{{ $t('forms.playDate') }}</label>
          <datepicker
            class="input-date"
            id="playDate"
            type="date"
            name="playDate"
            v-model="playDateFormData"
          />
        </div>
        <div class="col-4 p-md">
          <label for="playTime" class="m-b-xxs block">{{ $t('forms.playTime') }}</label>
          <styled-select id="playTime" v-model="playTimeFormData">
            <option v-for="time in bookableTimeOptions" :key="time.value" :value="time.value">
              {{ time.label }}
            </option>
          </styled-select>
        </div>
      </form>
    </card>
    <div v-if="showUpsells">
      <h2 class="m-t-lg m-b-xs">
        {{ $t('configurator.chooseSpecials', { tourName: 'Testtour' }) }}
      </h2>
      <!-- <styled-link class="m-b-lg block" href="#"
      @click.prevent="$emit('upsells-selected', [])">{{
        $t('configurator.nextWithoutSpecials')
      }}</styled-link> -->
      <form class="flex space-between">
        <!--Todo: Price Calc after merging w/ develop-->
        <checkbox-card
          v-for="upsell in filteredUpsells"
          :key="upsell.id"
          :id="upsell.id"
          :value="upsell.id"
          :checked="!!selectedUpsells.includes(upsell.id)"
          @change.native="e => selectUpsell(Number(e.target.value))"
          :title="upsell.Title"
          :price="getPrice(upsell.Price, upsell.PriceType)"
          :description="upsell.Description"
          :iconURL="assets.getUrl(upsell.Icon.url)"
          class="m-b-lg card-upsell"
          :footerButtons="{
            content: 'Bilder & Details ansehen',
          }"
          @footer-button-click="toggleModal(upsell)"
        />
        <div v-if="upsells.length % 3 !== 0" class="card-upsell" />
        <styled-button
          fullWidth
          @click.prevent="$emit('upsells-selected', selectedUpsells)"
          :disabled="nextDisabled"
          >{{ $t('forms.next') }}</styled-button
        >
      </form>
      <modal class="modal" v-if="modalOpen" @close="toggleModal({})">
        <card>
          <div
            :style="`background-image: url(${assets.getUrl(modalContent.TeaserImage.url)}`"
            class="modal-teaser"
          >
            <H2 class="p-l-xl p-b-md" font-family="Bitter" color="#ffffff" size="2rem">
              {{ modalContent.Title }}
            </H2>
          </div>
          <div class="p-l-xl p-r-xl flex space-between container-image">
            <div class="p-b-xl p-l-xl p-r-xl html-content" v-html="modalContent.LongDescription" />
            <div
              v-for="image in modalContent.Galery"
              :key="image.id"
              class="col-4 p-r-sm p-l-sm p-t-xl p-b-xl"
            >
              <img :src="assets.getUrl(image.url)" class="image-squared" />
            </div>
            <div class="col-6 font-xl p-t-lg">
              <!--Todo: Price Calc after merging w/ develop-->
              {{ getPrice(modalContent.Price, modalContent.PriceType) }}
            </div>
            <div class="col-6">
              <styled-button
                fullWidth
                class="m-b-xl"
                @click.prevent="
                  () => {
                    selectUpsell(modalContent.id);
                    toggleModal({});
                  }
                "
                >{{ $t('configurator.chooseSpecial') }}</styled-button
              >
            </div>
          </div>
        </card>
      </modal>
    </div>
  </div>
</template>
<script>
// getPrice()
import datepicker from 'vuejs-datepicker';
import ConfiguratorMixin from '@/mixins/configurator';
import card from '@/components/common/card';
// import styledInput from '@/components/common/styledInput';
import styledSelect from '@/components/common/styledSelect';
import styledButton from '@/components/common/styledButton';
import checkboxCard from '@/components/checkboxCard.vue';
// import styledLink from '@/components/common/styledLink';
import modal from '@/components/modal.vue';
import { H2 } from '@/components/common/styledHeading';
import { assets } from '@/agent';

function clearInvalidOption(value, options) {
  return options.find(option => option.value === value) ? value : '';
}

function getBookableTimeOptions(product, timeSuffix) {
  return (
    product?.BookingTimes?.map(({ BookableTime, FrontendValue }) => {
      const time = BookableTime.match(/^\d\d:\d\d/)?.[0];
      return {
        value: time,
        label: FrontendValue || `${time} ${timeSuffix}`,
      };
    }) ?? []
  );
}

function getBookableTimeOptionsLegacy(product, labelSuffix) {
  return (
    product?.PlayableTimes?.map(singleTime => ({
      label: `${singleTime} ${labelSuffix}`,
      value: singleTime,
    })) ?? []
  );
}

export default {
  name: 'upsell-selection',

  components: {
    card,
    // styledInput,
    styledSelect,
    styledButton,
    // styledLink,
    checkboxCard,
    datepicker,
    modal,
    H2,
  },

  computed: {
    /**
     * Show upsell section and emit event after all form fields are filled.
     */
    showUpsells() {
      return Boolean(
        this.peopleCountFormData &&
          this.playDateFormData &&
          (!this.playableTimes || this.playTimeFormData),
      );
    },

    /**
     * Filter upsells based on different filter methods.
     */
    filteredUpsells() {
      return (
        this.upsells?.filter(upsell => {
          const chosenDate = Date.parse(this.playDateFormData);
          const startDate = Date.parse(upsell.StartDate);
          const endDate = Date.parse(upsell.EndDate);

          if (!upsell.SpecificDates && startDate && endDate) {
            return chosenDate >= startDate && chosenDate <= endDate;
          }

          return upsell.AvailableDates.includes(this.playDateFormData);
        }) ?? []
      );
    },

    nextDisabled() {
      return this.selectedUpsells.length === 0;
    },
  },

  watch: {
    peopleCountFormData() {
      this.emitFormData();
    },

    playDateFormData() {
      this.emitFormData();
    },

    playTimeFormData() {
      this.emitFormData();
    },
  },

  mixins: [ConfiguratorMixin],

  props: {
    upsells: {
      type: Array,
      required: true,
    },
    selectedUpsells: {
      type: Array,
      required: true,
    },
    peopleCount: {
      type: String,
      default: '',
    },
    playDate: {
      Type: String,
      default: '',
    },
    playTime: {
      Type: String,
      default: '',
    },
    orderTitle: {
      Type: String,
      required: true,
    },
    minParticipants: {
      Type: Number,
      default: 5,
    },
    maxParticipants: {
      Type: Number,
      default: 40,
    },
    product: {
      Type: Object,
      required: true,
    },
  },

  data() {
    const bookableTimeOptions = this.product?.BookingTimes?.length
      ? getBookableTimeOptions(this.product, this.$t('forms.clock'))
      : getBookableTimeOptionsLegacy(this.product, this.$t('forms.clock'));

    return {
      assets,
      modalOpen: false,
      modalContent: {},
      bookableTimeOptions,
      peopleCountFormData: this.peopleCount,
      playDateFormData: this.playDate && new Date(this.playDate.replace(/-/g, '/')),
      playTimeFormData: clearInvalidOption(this.playTime, bookableTimeOptions),
    };
  },

  mounted() {
    window.scroll(0, 0);
  },

  methods: {
    /**
     * Changes modal state to its opposite and content for product details.
     * @param {String} modalContent - The content for the modal
     */
    toggleModal(modalContent) {
      this.modalContent = modalContent;
      this.modalOpen = !this.modalOpen;
    },

    emitFormData() {
      // Todo: Fix this - we form the date here like we would expect from html date input
      const date = this.playDateFormData;
      this.$emit('form-data-filled', {
        peopleCount: this.peopleCountFormData,
        playDate: date && `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
        playTime: this.playTimeFormData,
      });
    },

    selectUpsell(item) {
      if (this.selectedUpsells.includes(item)) {
        this.selectedUpsells.splice(this.selectedUpsells.indexOf(item), 1);
        return;
      }
      this.selectedUpsells.push(item);
    },

    generateGroupOptions(min, max, labelSuffix) {
      const groupSizes = [];
      // eslint-disable-next-line
      for (let i = min; i <= max; i++) {
        groupSizes.push({
          label: `${i} ${labelSuffix}`,
          value: i,
        });
      }
      return groupSizes;
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-teaser {
  position: relative;
  width: 100%;
  padding-top: 10rem;
  background-size: cover;
  background-position: center center;
}
// Todo: THis is a duplicate from extra selection. find a way to layout it once everywhere
.card-upsell {
  width: 100%;
  @media screen and (min-width: 35rem) {
    width: 48%;
  }
  @media screen and (min-width: 73rem) {
    width: 100%;
    max-width: 23rem;
  }
}

.container-image {
  overflow: hidden;
}

.image-squared {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
.input-date {
  input {
    position: relative;
    width: 100%;
    padding: 0.75rem;
    max-width: 100%;
    border: 0.05rem solid #e3e3e3;
    border-radius: 0.125rem !important;
    height: 2.8rem;
    background-color: #ffffff;
  }
}
</style>
